var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 9V15C22.75 17.5 22.25 19.25 21.13 20.38L14.75 14L22.48 6.27C22.66 7.06 22.75 7.96 22.75 9Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.48 6.27L7.01999 21.73C4.00999 21.04 2.75 18.96 2.75 15V9C2.75 4 4.75 2 9.75 2H15.75C19.71 2 21.79 3.26 22.48 6.27Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.13 20.38C20 21.5 18.25 22 15.75 22H9.75003C8.71003 22 7.81002 21.91 7.02002 21.73L14.75 14L21.13 20.38Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99002 7.98C7.67002 5.05 12.07 5.05 12.75 7.98C13.14 9.7 12.06 11.16 11.11 12.06C10.42 12.72 9.33003 12.72 8.63003 12.06C7.68003 11.16 6.59002 9.7 6.99002 7.98Z",
    stroke: "#292D32",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8446 8.70001H9.85359",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveMap);
export default __webpack_public_path__ + "static/media/live-map.3b1e4ce53f6c2c714ad06aac37d48e65.svg";
export { ForwardRef as ReactComponent };